import { PathOptions } from "leaflet";

export const pe_aeroportos = (feature: any): PathOptions => {
  return {
    color: "#6495ed",
    weight: 2,
    fillColor: "#87ceeb",
    fillOpacity: 0.7,
  };
};
